import React from "react";
import { string } from "prop-types";
import "./event-info-title.m.css";

export const EventInfoTitle = ({ children }) => {
  return (
    <div styleName="event-info-title">{children}</div>
  );
};

EventInfoTitle.propTypes = {
  children: string.isRequired,
};
